<template>
  <div class="ws-flex">
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: "WsFlex",
};
</script>
<style lang="scss">
@import "@/__vue2cmsstonevuetify/assets/scss/ws-flex.scss";
</style>